function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #000;\n        stroke-width: .04px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "g3"
}, /*#__PURE__*/React.createElement("g", {
  id: "g1"
}, /*#__PURE__*/React.createElement("circle", {
  id: "circle1",
  cx: 20.87,
  cy: 10.08,
  r: 1.53
}), /*#__PURE__*/React.createElement("path", {
  id: "path1-5",
  d: "m24.58,12.19c-.38-.19-.84-.06-1.03.33l-.67,1.26-2.95-1.86c-.11-.08-.25-.11-.4-.11h-3.26c-.29,0-.54.15-.67.4l-1.24,2.3c-.21.36-.06.84.31,1.03.11.06.25.1.36.1.27,0,.54-.15.67-.4l1.03-1.9h1.13l-3.39,6.32h-3.18c-.42,0-.77.34-.77.77s.34.77.77.77h3.64c.29,0,.54-.15.67-.4l1.34-2.47,2.2,2.05-.17,3.85c-.04.42.29.79.71.8h.04c.4,0,.75-.33.77-.73l.19-4.21c.02-.23-.08-.44-.25-.59l-1.86-1.72,1.95-3.64,2.22,1.4c.17.11.4.15.61.1s.38-.19.48-.38l1.05-2.01c.21-.36.08-.82-.31-1.03Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "path6",
  className: "cls-1",
  d: "m19.46,24.95c-.16-.06-.32-.21-.4-.39-.08-.19-.08-.21,0-2.2l.09-2.01-.14-.14c-.8-.77-2.07-1.92-2.1-1.9-.02.02-.34.61-.73,1.31-.61,1.12-.72,1.3-.88,1.41l-.18.13h-1.91c-1.3.02-1.97.01-2.09-.02-.1-.03-.25-.11-.34-.2-.39-.36-.3-.97.19-1.19.16-.07.31-.08,1.84-.08h1.66s1.69-3.15,1.69-3.15c.93-1.73,1.69-3.16,1.69-3.17s-.27-.02-.59-.01h-.59s-.53.98-.53.98c-.29.53-.59,1.02-.66,1.09-.36.33-.9.22-1.13-.23-.16-.32-.14-.39.59-1.75.37-.69.72-1.31.79-1.37.22-.24.24-.24,2.18-.24h1.78l.38.23c.21.13.93.57,1.59.99.66.42,1.21.76,1.21.75,0,0,.17-.31.36-.68.2-.37.4-.71.45-.77.19-.22.56-.28.83-.15.31.15.5.53.4.82-.1.3-1.17,2.29-1.29,2.4-.18.16-.44.23-.64.18-.09-.02-.66-.36-1.28-.75-.61-.39-1.15-.71-1.18-.71-.06,0-2,3.53-1.98,3.62,0,.02.43.43.94.91,1.07,1,1.07,1,1.12,1.17.02.08,0,1.02-.07,2.36-.1,2.13-.11,2.24-.2,2.4-.13.23-.39.38-.64.38-.1,0-.22-.01-.25-.03Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "path7",
  className: "cls-1",
  d: "m20.63,11.56c-.29-.04-.7-.26-.87-.45-.07-.08-.18-.25-.25-.37-.11-.2-.12-.27-.12-.66,0-.41,0-.45.15-.7.49-.9,1.66-1.07,2.38-.35.59.59.59,1.52,0,2.12-.35.35-.8.49-1.29.42Z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "g2-0"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1-58",
  className: "cls-2",
  d: "m0,0h15.55v15.55H0V0Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path2-9",
  d: "m6.48,4.53c0,2.5,2.03,4.53,4.53,4.54,1.22,0,2.39-.49,3.24-1.36v.06c0,3.58-2.9,6.48-6.48,6.48S1.3,11.35,1.3,7.77,4.2,1.3,7.77,1.3h.06c-.87.85-1.36,2.02-1.36,3.24Zm-3.89,3.24c0,2.86,2.32,5.18,5.18,5.18,1.92,0,3.68-1.06,4.58-2.75-3.13.74-6.27-1.2-7.01-4.34-.21-.88-.21-1.79,0-2.67-1.69.9-2.75,2.66-2.75,4.57Z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "path13",
  className: "cls-1",
  d: "m7.14,14.2c-2.8-.3-5.12-2.38-5.69-5.12-.29-1.42-.1-2.88.54-4.16,1.01-2.02,2.91-3.33,5.19-3.57.66-.07.63-.08.39.2-.44.52-.8,1.18-.96,1.81-.66,2.57.96,5.15,3.55,5.64.41.08,1.25.09,1.64.02.81-.15,1.57-.51,2.2-1.04.29-.24.27-.27.2.39-.15,1.37-.61,2.48-1.47,3.52-1.34,1.63-3.5,2.53-5.59,2.31Zm1.63-1.32c1.34-.25,2.57-1.07,3.34-2.22.26-.4.29-.49.14-.45-.67.16-1.63.17-2.32.03-.58-.12-1-.26-1.47-.5-1.99-.99-3.23-2.97-3.24-5.18,0-.52.03-.88.13-1.26.01-.06,0-.1-.03-.1-.13,0-.84.52-1.21.9-1.01,1.01-1.51,2.22-1.52,3.65,0,1.46.49,2.66,1.52,3.69.89.89,1.94,1.38,3.22,1.52.29.03,1.08-.01,1.45-.08Z"
});

const SvgMoon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "svg2",
  viewBox: "0 0 24.99 25.02",
  width: "24px",
  height: "24px",
  ref: svgRef
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/moon.db94ffe7.svg";
export { ForwardRef as ReactComponent };